// extracted by mini-css-extract-plugin
module.exports = {"result":"src-components-Main-Operators-game-styles--18cEI"};